'use strict';
import $ from 'jquery';

$.core = $.core || {};

$.core.envMode = window.ENV_MODE || 'production';

$.core.getPartialPathForEnvMode = function () {
    switch ($.core.envMode) {
        case 'development':
        case 'test':
            return 'app/';
        default:
            return 'dist/'
    }
};

$.core.setIotoolPath = function (path) {
    if ($.core.envMode === 'test') {
        return '/base/iotool/' + $.core.getPartialPathForEnvMode() + path;
    }

    return '/client/iotool/' + $.core.getPartialPathForEnvMode() + path;
};